(function () {
    'use strict';

    angular.module("imApp").factory("furnitureFabricsSService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 1181,
                    parameters: parms || {}
                });
            },
            listFurnitureFabrics: function (parms) {
                return $ihttp.post({
                    method: 1180,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
